<template>
  <section class="section-hero section-shaped my-0">
    <div class="shape shape-style-1 shape-primary">
      <span class="span-150"></span>
      <span class="span-50"></span>
      <span class="span-50"></span>
      <span class="span-75"></span>
      <span class="span-100"></span>
      <span class="span-75"></span>
      <span class="span-50"></span>
      <span class="span-100"></span>
      <span class="span-50"></span>
      <span class="span-100"></span>
    </div>
    <div class="container shape-container d-flex align-items-center">
      <div class="col px-0">
        <div class="row justify-content-center align-items-center">
          <div class="col-lg-12 text-center">
            <form>
            <section v-if="step == 1">
              <FilterSelect></FilterSelect>
            </section>
            <section v-if="step == 2">
              <CountrySelect></CountrySelect>
            </section>
             <section v-if="step == 3">
              <Traveldatefromto></Traveldatefromto>
            </section>
            <div class="btn-wrapper">
              
               <base-button
                v-if="step!=1"
                @click.prevent="Prevstep"
                tag="a"
                href="#"
                class="mb-3 mb-sm-0"
                type="white"
                icon="fa fa-chevron-left"
              >Previous</base-button>
              <base-button
                v-if="step!=totalstep"
                @click.prevent="nextstep"
                tag="a"
                href="#"
                class="mb-3 mb-sm-0"
                type="info"
                icon="fa fa-chevron-right"
              >Next</base-button>
             
              <base-button
                v-if="step==3"
                @click.prevent="sendEnquiry"
                tag="a"
                href="#"
                class="mb-3 mb-sm-0"
                type="white"
                icon="fa fa-save"
              >Submit</base-button>
            </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import CountrySelect from "./CountrySelect";
import FilterSelect from "./FilterSelect";
import Traveldatefromto from "./Traveldatefromto";

export default {
  components: {
    CountrySelect,
    FilterSelect,
    Traveldatefromto
  },
  data() {
    return {
      step: 1,
      totalstep: 3,
     
    };
  },
  methods: {
    nextstep: function() {
      this.step++;
    },
    Prevstep: function() {
      this.step--;
    },
    sendEnquiry: function() {
      
    }
  }
};
</script>
<style>
</style>
